import { z } from 'zod'

// タグはDBテーブルで動的管理するため、Enumではなく自由文字列
export const TagSchema = z.string().min(1, { message: 'タグ名を入力してください。' })
export const LessonLevelEnum = z.enum(['ENTRY', 'BASIC', 'ADVANCED', 'EXPERT'])
export const LessonTypeEnum = z.enum(['video', 'external'])

export const LessonSchema = z.object({
  title: z.string().min(3, { message: 'タイトルは3文字以上で入力してください。' }),
  description: z.string().min(1, { message: 'レッスン説明を入力してください。' }).optional(),
  type: LessonTypeEnum,
  content: z.string().optional(),
  externalUrl: z
    .string()
    .url({ message: '有効な研修URLを入力してください。' })
    .optional()
    .or(z.literal('')),
  videoTotalDurationSeconds: z.number().int().positive().optional(),
  level: LessonLevelEnum,
  downloadable: z.boolean().optional(),
  isPublished: z.boolean().optional(),
})

export const CreateLessonSchema = LessonSchema.omit({ isPublished: true })
export const UpdateLessonSchema = LessonSchema.partial()

export const CourseFilterSchema = z.object({
  tags: z.array(TagSchema).min(1, { message: '少なくとも1つのタグを選択してください。' }),
  level: LessonLevelEnum,
})

export type LessonInput = z.infer<typeof LessonSchema>
export type CreateLessonInput = z.infer<typeof CreateLessonSchema>
export type UpdateLessonInput = z.infer<typeof UpdateLessonSchema>
export type CourseFilterInput = z.infer<typeof CourseFilterSchema>

// ─── Response schemas (GET レスポンス形状) ───────────────
const dateOrString = z.union([z.date(), z.string()])

/** GET /api/lessons — 一覧要素 */
export const LessonResponseSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  type: LessonTypeEnum,
  content: z.string().nullable(),
  videoBlobName: z.string().nullable(),
  externalUrl: z.string().nullable(),
  videoTotalDurationSeconds: z.number().nullable(),
  level: z.string(),
  downloadable: z.boolean().nullable(),
  videoOriginalFilename: z.string().nullable(),
  videoMimeType: z.string().nullable(),
  videoFilesizeBytes: z.number().nullable(),
  isPublished: z.boolean(),
  tenantId: z.string().nullable(),
  createdAt: dateOrString,
  updatedAt: dateOrString,
})

/** GET /api/lessons/:id — レッスン詳細（tagId付き） */
export const LessonDetailResponseSchema = LessonResponseSchema.extend({
  tagId: z.string().nullable(),
})

export type LessonResponse = z.infer<typeof LessonResponseSchema>
export type LessonDetailResponse = z.infer<typeof LessonDetailResponseSchema>

export const CreateTagSchema = z.object({
  name: z.string().min(1),
})

export type CreateTagInput = z.infer<typeof CreateTagSchema>
